import type { SVGProps } from "react";
import * as React from "react";
const SvgDustLogoSquareMonoWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M12 24c6.627 0 12-5.373 12-12 0 6.627 5.373 12 12 12H12Zm0 12a6 6 0 0 1 0-12H0V0h12c6.627 0 12 5.373 12 12V0h24v12c0 6.627-5.373 12-12 12h12v12H36v12H24V36H12Zm0 0a6 6 0 0 1 0 12H0V36h12Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDustLogoSquareMonoWhite;
